enum Modals {
  Base = 'BASE',
  Portal = 'PORTAL',
  Null = 'null',
}

enum GoTos {
  Dashboard = 'DASHBOARD',
}

export { Modals, GoTos };
